module.exports = __webpack_public_path__ + "static/media/IMG_8034_.d6449949.png";